const selectMissionObjectives = state => state.data.missionObjectives

const MissionObjectiveDataStoreSelectors = {
  missionObjectives: selectMissionObjectives
}

export default MissionObjectiveDataStoreSelectors
